import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import OfficeBrand from './OfficeBrand'
import { useAuth } from './hooks/useAuth'

export default function WorkspaceLogin() {
  const { tenant } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const { login } = useAuth()
  const [slug, setSlug] = useState('')
  const [email, setEmail] = useState('')
  const [workspace, setWorkspace] = useState<{ name: string; kind: string } | null>(null)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  useEffect(() => {
    let cancelled = false
    setWorkspace(null); setError(new URLSearchParams(location.search).get('error') || '')
    if (tenant) void fetch(`/api/auth/workspaces/${encodeURIComponent(tenant)}`, { cache: 'no-store' }).then(async response => {
      if (!response.ok) throw new Error(response.status === 404 ? 'Workspace not found. Check the link with your administrator.' : 'Workspace sign-in is unavailable. Try again shortly.')
      const value = await response.json()
      if (!cancelled) setWorkspace(value)
    }).catch(e => { if (!cancelled) setError(e.message) })
    return () => { cancelled = true }
  }, [tenant, location.search])
  return <div className="product-site folio-auth"><div className="product-container">
    <header className="product-nav"><Link to="/" aria-label="Folio home"><OfficeBrand /></Link><Link to="/login">Choose workspace</Link></header>
    <main className="product-hero"><div><span className="product-kicker">{workspace?.kind === 'family' ? 'Family workspace' : 'Team workspace'}</span>
      <h1>{workspace?.name || 'Your work.'}<br /><em>Your space.</em></h1>
      <p className="product-lead">One email address and password across your workspaces. Each workspace keeps its own files, people and permissions.</p>
      {tenant && <p>Workspace address: <strong>{tenant}</strong></p>}
    </div><form className="product-auth" onSubmit={async event => {
      event.preventDefault(); setError('')
      if (!tenant) {
        navigate(`/t/${encodeURIComponent(slug.trim().toLowerCase())}/login`, { state: location.state }); return
      }
      setBusy(true)
      try { await login(typeof location.state?.from === 'string' ? location.state.from : '/', email.trim().toLowerCase(), tenant) }
      catch (e) { setError(e instanceof Error ? e.message : 'Sign-in is unavailable'); setBusy(false) }
    }}><OfficeBrand /><h2>{workspace ? `Sign in to ${workspace.name}` : tenant ? 'Open your workspace' : 'Find your workspace'}</h2>
      {tenant ? <><p>Continue with your shared Folio account. Access is checked for this workspace.</p>
        <label className="folio-auth-label" htmlFor="folio-email">Email address</label>
        <input id="folio-email" className="folio-auth-input" type="email" autoComplete="username" required maxLength={254} value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" disabled={!workspace || busy} />
      </> : <><p>Enter the workspace address from your administrator’s sign-in link.</p>
        <label className="folio-auth-label" htmlFor="folio-workspace">Workspace address</label>
        <input id="folio-workspace" className="folio-auth-input" required pattern="[a-z][a-z0-9-]{2,39}" value={slug} onChange={e => setSlug(e.target.value.toLowerCase())} placeholder="Workspace address" autoCapitalize="none" spellCheck={false} />
      </>}
      {error && <p role="alert" className="product-alert">{error}</p>}
      <button className="product-button" disabled={busy || Boolean(tenant && !workspace)}>{busy ? 'Redirecting…' : tenant ? 'Continue with email' : 'Open workspace'}</button>
      <p className="product-subtle">Your password is entered securely at Contextful sign-in. Joining a workspace never changes your existing password.</p>
    </form></main>
  </div></div>
}
